import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Survey from "./Survey";
import Loading from "./Loading";
import Error from "./Error";
import { TAnswers, ISurvey, InvitationStatus } from "../surveyTypes";
import SurveyCompleted from "./SurveyCompleted";
import surveyReducer from "../reducers";
import axios from "axios";

const SurveyRoute: React.FC = () => {
  const baseURL = process.env.REACT_APP_VTSURVEY_BASE_URL || "";
  const { invitationId } = useParams();
  const [loading, setLoading] = useState(false);
  const [invitationStatus, setInvitationStatus] = useState(0);
  const [survey, setSurvey] = useState<ISurvey>();
  const [answers, setAnswers] = React.useState<TAnswers>({});
  const [errorMessage, setErrorMessage] = React.useState("");
  const [statusCode, setStatusCode] = React.useState(0);

  const fetchSurvey = async (baseURL: string, invitationId: string) => {
    const path = `/api/campaigns/invitation/${invitationId}/survey.json`;
    const fullURL = baseURL + path;
    setLoading(true);
    try {
      const response = await axios.get(fullURL);
      setStatusCode(response.status);
      const result = surveyReducer(response.data);
      setInvitationStatus(result.invitationStatus);
      setAnswers(result.answers);
      setSurvey(result.survey);
    } catch (error) {
      const newErrorMessage: string =
        "Sorry, we could not find a survey for the request ID.";
      setErrorMessage(newErrorMessage);
      error.response &&
        error.response.status &&
        setStatusCode(error.response.status);
    } finally {
      setLoading(false);
    }
  };
  // get the survey details by campaign request number
  useEffect(() => {
    fetchSurvey(baseURL, invitationId);
  }, [invitationId, baseURL]);

  return (
    <React.Fragment>
      {loading && <Loading />}
      {survey && invitationStatus === InvitationStatus.AWAITING && (
        <Survey
          invitationId={invitationId}
          survey={survey}
          initialAnswers={answers}
          setInvitationStatus={setInvitationStatus}
        />
      )}
      {errorMessage && (
        <Error
          message={errorMessage}
          campaignRequestId={invitationId}
          statusCode={statusCode}
        />
      )}
      {invitationStatus === 2 && <SurveyCompleted />}
    </React.Fragment>
  );
};

export default SurveyRoute;
